import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { ROUTE } from 'src/constants/routes';

import { LogoImage, MailIcon, TelegramIcon } from 'src/assets';
import './footer.scss';

export const Footer = () => {
  const { t, i18n } = useTranslation();

  const renderSocialItem = useCallback(({ image, label, value, link }) => {
    return (
      <Link className="social-item" to={link}>
        <img src={image} alt={image} />
        <div className="social-item-content">
          <div className="social-item-label">{label}</div>
          <div className="social-item-value">{value}</div>
        </div>
      </Link>
    );
  }, []);

  const renderInfoItem = useCallback(({ title, content }) => {
    const contentByType = typeof content === 'function' ? content() : content;

    return (
      <div className="info-item">
        <div className="info-item-title">{title}</div>
        <div className="info-item-row">
          <div className="info-item-row--left" />
          <div className="info-item-row--right" />
        </div>
        <div className="info-item-content">{contentByType}</div>
      </div>
    );
  }, []);

  const renderLink = useCallback(
    (title, to) => {
      return (
        <Link to={to?.replace(':language', i18n.language)} className="info-item--link">
          {title}
        </Link>
      );
    },
    [i18n.language],
  );

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section section1">
          <div className="logo">
            <Link to={ROUTE.HOME}>
              <img src={LogoImage} alt={LogoImage} />
            </Link>
          </div>
          {renderSocialItem({
            image: MailIcon,
            label: t('footer:mail'),
            value: 'example@gmail.com',
            link: 'mailto:example@gmail.com',
          })}
          {renderSocialItem({
            image: TelegramIcon,
            label: t('footer:telegram'),
            value: '#name3',
            link: 'https://web.telegram.org',
          })}

          <div className="copyright">
            © Name3, {moment().year()} {t('footer:year')}
          </div>
        </div>
        <div className="footer-section section2">
          {renderInfoItem({
            title: t('footer:aboutUs'),
            content: () => (
              <>
                {renderLink(t('footer:markets'), ROUTE.MARKETS.MARKETS)}
                {renderLink(t('footer:platform'), ROUTE.PLATFORM)}
                {/* {renderLink(t('footer:aboutUs'), ROUTE.ABOUT_COMPANY)} */}
                {renderLink(t('footer:tradingSessions'), ROUTE.MARKETS.TRADING_SESSION)}
                {renderLink(t('footer:instruments'), ROUTE.MARKETS.INSTRUMENTS)}
                {renderLink(t('footer:aboutCompany'), ROUTE.ABOUT_COMPANY)}
                {renderLink(t('footer:contacts'), ROUTE.CONTACTS)}
                {renderLink(t('footer:privacyPolicy'), ROUTE.PRIVACY_POLICY)}
              </>
            ),
          })}
        </div>
        <div className="footer-section section3">
          {renderInfoItem({ title: t('footer:info'), content: t('footer:information') })}
        </div>
      </div>
    </footer>
  );
};
